export default __webpack_public_path__ + "static/media/appstore.35af46df.png";